import { userClient } from '../config/api';

export interface ProfileData {
  userId: string;
  name: string;
  email: string;
  phoneNumber?: string;
  photoUrl?: string;
  moduleType: string;
}

export interface UpdateProfileData {
  name: string;
  email: string;
  phoneNumber?: string;
  photoUrl?: string;
  currentPassword?: string;
  newPassword?: string;   
}

class ProfileService {
  async getProfile(): Promise<ProfileData> {
    const response = await userClient.get('/api/users/profile');
    return response.data.data;
  }

  async updateProfile(data: UpdateProfileData): Promise<void> {
    await userClient.put('/api/users/profile', data);
  }
}

export const profileService = new ProfileService();
